import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { toggleLoader } from "../shared/actions/setting";

const useUserApi = () => {
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);

  const fetchUsers = () => {
    dispatch(toggleLoader(true));
    axios
      .get(process.env.REACT_APP_HOST + `/users`)
      .then((res) => {
        setUsers(res.data);
        dispatch(toggleLoader(false));
      })
      .catch((error) => {
        toast.error("Failed to fetch users.");
        dispatch(toggleLoader(false));
      });
  };

  const createUser = (userData, onSuccess) => {
    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_HOST + `/user/create`, userData)
      .then((res) => {
        toast.success("User created successfully!");
        fetchUsers();
        dispatch(toggleLoader(false));
        onSuccess && onSuccess();
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Failed to create user.");
        dispatch(toggleLoader(false));
      });
  };

  const editUser = (userData, onSuccess) => {
    dispatch(toggleLoader(true));
    axios
      .patch(process.env.REACT_APP_HOST + `/user/edit`, userData)
      .then((res) => {
        toast.success("User updated successfully!");
        fetchUsers();
        dispatch(toggleLoader(false));
        onSuccess && onSuccess();
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Failed to update user.");
        dispatch(toggleLoader(false));
      });
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    users,
    createUser,
    editUser,
  };
};

export default useUserApi;
